import React from 'react'
import GenericPullAndPushToolView from '../GenericPullAndPushToolView'
import QualysInfraConfigListing from './QualysInfraConfigListing'
import QualysInfraCredentialsForm from './QualysInfraCredentialsForm'

export default function QualysInfraPullAndPushView(props) {
    return (
        <GenericPullAndPushToolView 
            {...props}
            PullCredentialForm={QualysInfraCredentialsForm}
            PullConfigListingView={QualysInfraConfigListing}
        />
    )
}